// BFX
import * as CubiqTS from "shared/cubiq-model-multi-asset";

/** Style object used in ngClass */
interface StyleMap {
  [className: string]: (params: { data: any }) => boolean;
}

/**
 * Shared set of row styles for all trade-related blotters
 * @returns
 */
function getBaseRowStyles(): StyleMap {
  return {
    "deal-confirmed-with-error": function (params) {
      return (
        params.data.confirmedSalesUserId != null &&
        CubiqTS.OrderDealState.FILL_ERROR === params.data.dealStateId
      );
    },
    "deal-complete": function (params) {
      return (
        params.data.confirmedSalesUserId == null &&
        CubiqTS.RequestOrderType.CALL != params.data.requestOrderType &&
        CubiqTS.OrderDealState.COMPLETED == params.data.dealStateId
      );
    },
    "deal-failed": function (params) {
      return (
        params.data.confirmedSalesUserId == null &&
        CubiqTS.RequestOrderType.CALL != params.data.requestOrderType &&
        CubiqTS.OrderDealState.ACK_TIME_OUT == params.data.dealStateId
      );
    },
    "deal-failed-nak": function (params) {
      return (
        params.data.confirmedSalesUserId == null &&
        CubiqTS.RequestOrderType.CALL != params.data.requestOrderType &&
        CubiqTS.OrderDealState.NAK == params.data.dealStateId
      );
    },
    "deal-held": function (params) {
      return (
        params.data.confirmedSalesUserId == null &&
        CubiqTS.RequestOrderType.CALL != params.data.requestOrderType &&
        CubiqTS.OrderDealState.STP_HOLD == params.data.dealStateId
      );
    },
    "deal-error": function (params) {
      return (
        params.data.confirmedSalesUserId == null &&
        CubiqTS.RequestOrderType.CALL != params.data.requestOrderType &&
        CubiqTS.OrderDealState.FILL_ERROR == params.data.dealStateId
      );
    },
    "fill-pending": function (params) {
      return (
        CubiqTS.OrderDealState.FILL_PENDING == params.data.dealStateId ||
        CubiqTS.OrderDealState.ACTIVE === params.data.dealStateId ||
        CubiqTS.OrderDealState.PENDING == params.data.dealStateId
      );
    },
  };
}

/**
 * Create an object used in ngClass for all row styles for Client trades
 * @returns
 */
export function getClientTradeRowStyles(): StyleMap {
  const styleMap = getBaseRowStyles();
  styleMap["deal-confirmed"] = function (params) {
    return (
      params.data.confirmedSalesUserId != null &&
      CubiqTS.OrderDealState.FILL_ERROR !== params.data.dealStateId
    );
  };
  styleMap["deal-disabled"] = function (params) {
    return (
      params.data.confirmedSalesUserId == null &&
      CubiqTS.RequestOrderType.CALL != params.data.requestOrderType &&
      CubiqTS.OrderDealState.DONE_NO_STP == params.data.dealStateId
    );
  };
  return styleMap;
}

/**
 * Create an object used in ngClass for all row styles for Risk trades
 * @returns
 */
export function getRiskTradeRowStyles(): StyleMap {
  const styleMap = getBaseRowStyles();
  styleMap["deal-confirmed"] = function (params) {
    return (
      (params.data.confirmedSalesUserId != null &&
        CubiqTS.OrderDealState.FILL_ERROR !== params.data.dealStateId) ||
      (params.data.confirmedSalesUserId == null &&
        CubiqTS.RequestOrderType.CALL != params.data.requestOrderType &&
        CubiqTS.OrderDealState.DONE_NO_STP == params.data.dealStateId)
    );
  };
  return styleMap;
}
